import React from 'react';
import { CSVLink } from 'react-csv';
import moment from 'moment';

type LabelKeyObject = {
  key: string;
  label: string;
};

type Props = {
  data: {}[] | undefined;
  headers: LabelKeyObject[];
  fileName?: string;
  className?: string;
};

export const Export = ({ data, headers, fileName, className }: Props) => {
  const csvReport = {
    data: data !== undefined ? data : [],
    headers: headers,
    filename: fileName
      ? fileName + moment(new Date()).format('_MM/dd/yyyy_hh-mm') + '.csv'
      : undefined,
  };

  return (
    <CSVLink {...csvReport} className={'btn ' + className}>
      Export to CSV
    </CSVLink>
  );
};
